import { UUID } from '@/types';
import React, { FC } from 'react';
import { Permission } from '@/permissions/Permission';
import { Sticker } from '@trevor/ui-components';

type DashboardStickersProps = {
  datasourceId: UUID;
  dashboardId: UUID;
  isPublic: boolean;
  isEmbedded: boolean;
  numberOfGuestUsers: number;
};

export const DashboardStickers: FC<DashboardStickersProps> = ({
  datasourceId,
  dashboardId,
  isPublic,
  isEmbedded,
  numberOfGuestUsers,
}) => {
  const numberOfGuestUsersLabel = `${numberOfGuestUsers} guest ${
    numberOfGuestUsers > 1 ? 'users' : 'user'
  }`;

  return (
    <Permission
      permissionPath={`${datasourceId}.dashboards.${dashboardId}.write`}
    >
      <>
        {isPublic && <Sticker type="info" iconName="eye" label="Public" />}
        {numberOfGuestUsers > 0 && (
          <Sticker
            type="share"
            iconName="user"
            label={numberOfGuestUsersLabel}
          />
        )}
        {isEmbedded && (
          <Sticker type="success" iconName="web" label="Embedded" />
        )}
      </>
    </Permission>
  );
};
